const theme = {
  colors: {
    white: '#fff',
    title: 'red',
    text: '#000',
    value: 'red',
    bgHeader: '#1d528d',
    bgFooter: '#1d528d',
    bgMain: '#f5f3f3',
    bgContainer: '#eb8a1b',
    primaryButton: '#07c',
    secondaryButton: '#05a',
    background: '#fff',
  },
  space: [0, 2, 4, 8, 16, 32, 64, 128, 256],
  fonts: {
    title: 'Roboto',
    button: '',
  },
  fontSizes: {
    xs: 12,
    s: 14,
    m: 16,
    l: 18,
    xl: 64,
  },
  fontWights: {
    normal: 400,
    bold: 700,
  },
  lineHeights: {
    title: 1.5,
    button: 1.2,
    text: 1.125,
  },
  borders: {
    none: 'none',
    normal: '1px solid',
  },
  radii: {
    none: 'none',
    button: '3px',
    container: '6px',
  },
};

export default theme;
